import { SafeHtml } from '@angular/platform-browser';

/**
 * model for Country or Location object, used with `/admin/country` endpoints
 */
export interface Country {
  countryId?: number;
  // country name
  name?: string;
  // country phone number prefix
  countryCode?: string;
  // short abbreviation
  abbreviation?: string;
  // long country abbreviation
  longAbbreviation?: string;
  // HTML-friendly description of country's history, current affairs
  background?: string | SafeHtml;
  // country hashtag
  countryHashtag?: string;
  // whether the location is in the USA
  isInUS?: boolean;
  // for use with social media sharing buttons
  metadata?: string;
}
